module.exports = __webpack_public_path__ + "static/media/Pastry Cream & Custard.caf310fe.jpg";